
    import { Vue, Component, Mixins } from 'vue-property-decorator';
    import { YModal } from '@components/index';
    import ProfileAddressEditor from '@rogues/ProfileAddressEditor/shared/profileAddressEditor';

    interface ModalRef extends Vue {
        open(): void;
        close(): void;
    }

    @Component({
        components: {
            YModal,
        },
    })
    /**
     * @name Modal
     */
    export default class Modal extends Mixins(ProfileAddressEditor) {
        responsive = {
            modal: {
                992: 'medium',
                768: 'normal',
            },
            button: {
                450: 'small',
            },
        }

        /**
         * Refs types
         */
        $refs!: {
            addressEditorModal: ModalRef;
        };

        /**
         * Close modal
         */
        closeModal() {
            this.$refs.addressEditorModal.close();
        }

        /**
         * Open Editor modal
         *
         * @param {object} address
         * @param {object} divisionConfig
         */
        openModal(address: object, divisionConfig: object) {
            if (divisionConfig) {
                this.divisionConfig = divisionConfig;
            }
            if (address) {
                this.address = address;
            } else {
                this.address = {
                    map_lat : '',
                    map_long: '',
                    division: {
                        province     : null,
                        city         : null,
                        neighbourhood: null,
                    },
                };
            }
            this.$refs.addressEditorModal.open();
        }

        /**
         * Model from address form
         *
         * @param {object} model
         */
        formModel(model) {
            this.$set(this, 'model', model);
        }
    }
